import { VscLoading } from "react-icons/vsc";

export default function Loader() {
    return (
        <div>
            <VscLoading className="animate-spin text-primary-200" fontSize={82} />
        </div>
    )
}